// extracted by mini-css-extract-plugin
module.exports = {"testDetails_lists_text":"ListItem_testDetails_lists_text__gDV8X"};